// import { createSelector } from '@reduxjs/toolkit';

export const getInfoUserSignIn = (state) => state.signInUser;
export const getStateHeaderSlice = (state) => state.headerSlice;
